import { logUsage, PerformanceDatapoint } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import {
    accountRankTypeChecker,
    BootState,
    getAccountByMailboxInfo,
} from 'owa-account-source-list-store';
import { PolicyStateTypeEnum } from 'owa-account-source-list-types';

/**
 * Lightweight account-error check using only stores already in the AppBoot
 * bundle. Covers boot and policy errors — the most common failure modes
 * visible in the folder tree.
 */
function hasLightweightAccountError(mailboxInfo: MailboxInfo): boolean {
    const accountSource = getAccountByMailboxInfo(mailboxInfo);
    if (accountSource && accountRankTypeChecker.isCoprincipal(accountSource)) {
        if (accountSource.bootState === BootState.StartupError) {
            return true;
        }
        if (accountSource.policyState === PolicyStateTypeEnum.PolicyError) {
            return true;
        }
    }

    return false;
}

export function logRootFolderNodeCollapse(
    treeType: string,
    distinguishedFolderId: string,
    mailboxInfo: MailboxInfo
): void {
    logUsage('Triage_ToggleFolderCollapse', mailboxInfo, [
        distinguishedFolderId,
        treeType,
        hasLightweightAccountError(mailboxInfo),
    ]);
}

export function createRootFolderExpansionDatapoint(
    treeType: string,
    distinguishedFolderId: string,
    mailboxInfo: MailboxInfo
): PerformanceDatapoint {
    const dp = new PerformanceDatapoint('FP_RootFolderNodeExpand', mailboxInfo);
    dp.addCustomData({
        treeType,
        distinguishedFolderId,
        hasAccountStateError: hasLightweightAccountError(mailboxInfo),
    });
    return dp;
}
